import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon, AwardIcon } from 'lucide-react';
const COURSES = [{
  title: 'A-Kurs White Aesthetics',
  points: 15,
  slug: 'white-aesthetics',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/whiteaestetics.jpg'
}, {
  title: 'B-Kurs Red Aesthetics',
  points: 16,
  slug: 'red-aesthetics',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/kursweichgewebe.jpg'
}, {
  title: 'C-Kurs Funktion',
  points: 16,
  slug: 'funktionsanalyse-therapie',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/kursfunktionellezahnmedizin.jpg'
}, {
  title: 'D-Kurs Champions League',
  points: 15,
  slug: 'champions-league',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/kurspraxismanagement.jpeg'
}, {
  title: 'Female Boss',
  points: 7,
  slug: 'female-boss',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/kursfemaleboss.jpg'
}, {
  title: 'Alignertherapie',
  points: 16,
  slug: 'alignertherapie',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/kursalignertherapie.jpg'
}];
const SPEAKERS = [{
  name: 'Dr. Thomas Schwenk',
  title: 'Prothetik & Parodontologie',
  slug: 'dr-thomas-schwenk',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/schwenk.jpg'
}, {
  name: 'Dr. Marcus Striegel',
  title: 'Ästhetische Zahnheilkunde',
  slug: 'dr-marcus-striegel',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/striegel.jpg'
}, {
  name: 'Dr. Johanna Herzog',
  title: 'Sportzahnmedizin',
  slug: 'dr-johanna-herzog',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/herzog.jpg'
}];
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isReferentenDropdownOpen, setIsReferentenDropdownOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsDropdownOpen(false);
    setIsReferentenDropdownOpen(false);
  }, [location.pathname]);
  return <header className={`fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md transition-all duration-300 ${isScrolled ? 'h-16 shadow-lg border-b border-slate-200' : 'h-24 border-b border-transparent'}`} data-id="element-303">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full" data-id="element-304">
        <div className="flex justify-between items-center h-full" data-id="element-305">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-306">
            <Link to="/" className="flex items-center" data-id="element-307">
              <img src="https://cdn.rawproductionsgmbh.de/2n/home/sitelogo.png" alt="2N Zahnärztliche Fortbildungen Logo" className={`w-auto object-contain transition-all duration-300 ${isScrolled ? 'h-10' : 'h-14'}`} data-id="element-308" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex space-x-8 items-center h-full" data-id="element-309">
            {/* Kurse Dropdown */}
            <div className="relative h-full flex items-center group" onMouseEnter={() => setIsDropdownOpen(true)} onMouseLeave={() => setIsDropdownOpen(false)} data-id="element-310">
              <button className="flex items-center gap-1 text-slate-700 hover:text-[#3b7780] font-bold transition-colors" data-id="element-311">
                Kurse{' '}
                <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`} data-id="element-312" />
              </button>

              {/* Dropdown Panel */}
              <div className={`absolute top-full left-1/2 -translate-x-1/2 w-[600px] bg-white rounded-xl shadow-2xl border border-slate-100 transition-all duration-200 origin-top ${isDropdownOpen ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-4 invisible'}`} data-id="element-313">
                <div className="p-6 grid grid-cols-2 gap-4" data-id="element-314">
                  {COURSES.map(course => <Link key={course.slug} to={`/kurse/${course.slug}`} className="flex items-center gap-4 p-3 rounded-lg hover:bg-slate-50 transition-colors group/item" data-id="element-315">
                      <img src={course.img} alt={course.title} className="w-12 h-12 rounded-lg object-cover shadow-sm" data-id="element-316" />
                      <div data-id="element-317">
                        <h4 className="font-bold text-slate-700 group-hover/item:text-[#3b7780] transition-colors text-sm" data-id="element-318">
                          {course.title}
                        </h4>
                        <div className="flex items-center gap-1 mt-1" data-id="element-319">
                          <AwardIcon className="w-3 h-3 text-[#59d0d4]" data-id="element-320" />
                          <span className="text-xs font-semibold text-[#748282]" data-id="element-321">
                            {course.points} Punkte
                          </span>
                        </div>
                      </div>
                    </Link>)}
                </div>
                <div className="bg-slate-50 p-4 rounded-b-xl border-t border-slate-100 text-center" data-id="element-322">
                  <Link to="/#kurse" className="text-sm font-bold text-[#3b7780] hover:text-[#2d5f66]" data-id="element-323">
                    Alle Kurse ansehen &rarr;
                  </Link>
                </div>
              </div>
            </div>

            {/* Referenten Dropdown */}
            <div className="relative h-full flex items-center group" onMouseEnter={() => setIsReferentenDropdownOpen(true)} onMouseLeave={() => setIsReferentenDropdownOpen(false)} data-id="element-324">
              <button className="flex items-center gap-1 text-slate-700 hover:text-[#3b7780] font-bold transition-colors" data-id="element-325">
                Referenten{' '}
                <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${isReferentenDropdownOpen ? 'rotate-180' : ''}`} data-id="element-326" />
              </button>

              {/* Dropdown Panel */}
              <div className={`absolute top-full left-1/2 -translate-x-1/2 w-[350px] bg-white rounded-xl shadow-2xl border border-slate-100 transition-all duration-200 origin-top ${isReferentenDropdownOpen ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-4 invisible'}`} data-id="element-327">
                <div className="p-4 flex flex-col gap-2" data-id="element-328">
                  {SPEAKERS.map(speaker => <Link key={speaker.slug} to={`/referenten/${speaker.slug}`} className="flex items-center gap-4 p-3 rounded-lg hover:bg-slate-50 transition-colors group/item" data-id="element-329">
                      <img src={speaker.img} alt={speaker.name} className="w-10 h-10 rounded-full object-cover shadow-sm border border-slate-200" data-id="element-330" />
                      <div data-id="element-331">
                        <h4 className="font-bold text-slate-700 group-hover/item:text-[#3b7780] transition-colors text-sm" data-id="element-332">
                          {speaker.name}
                        </h4>
                        <p className="text-xs font-semibold text-[#748282] mt-0.5" data-id="element-333">
                          {speaker.title}
                        </p>
                      </div>
                    </Link>)}
                </div>
                <div className="bg-slate-50 p-4 rounded-b-xl border-t border-slate-100 text-center" data-id="element-334">
                  <Link to="/#referenten" className="text-sm font-bold text-[#3b7780] hover:text-[#2d5f66]" data-id="element-335">
                    Alle Referenten ansehen &rarr;
                  </Link>
                </div>
              </div>
            </div>

            <Link to="/termine" className="text-slate-700 hover:text-[#3b7780] font-bold transition-colors" data-id="element-336">
              Termine
            </Link>
            <Link to="/mediathek" className="text-slate-700 hover:text-[#3b7780] font-bold transition-colors" data-id="element-337">
              Mediathek
            </Link>
            <Link to="/kontakt" className="text-slate-700 hover:text-[#3b7780] font-bold transition-colors" data-id="element-338">
              Kontakt
            </Link>

            <Link to="/kontakt" className="bg-[#3b7780] hover:bg-[#2d5f66] text-white px-6 py-2.5 rounded-md font-bold transition-all hover:scale-105 hover:shadow-lg active:scale-95" data-id="element-339">
              Jetzt buchen
            </Link>
          </nav>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center" data-id="element-340">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-700 hover:text-[#3b7780] focus:outline-none p-2" data-id="element-341">
              {isMobileMenuOpen ? <XIcon className="h-7 w-7" data-id="element-342" /> : <MenuIcon className="h-7 w-7" data-id="element-343" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Overlay */}
      {isMobileMenuOpen && <div className="lg:hidden" style={{
      position: 'fixed',
      top: isScrolled ? 64 : 96,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 9999,
      backgroundColor: 'rgba(0,0,0,0.5)',
      backdropFilter: 'blur(4px)'
    }} onClick={() => setIsMobileMenuOpen(false)} data-id="element-344">
          <div className="animate-slideInRight" style={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        width: '80%',
        maxWidth: '384px',
        backgroundColor: 'white',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column'
      }} onClick={e => e.stopPropagation()} data-id="element-345">
            <div className="p-6 flex-1 overflow-y-auto space-y-6" data-id="element-346">
              <div className="space-y-4" data-id="element-347">
                <h3 className="text-xs font-extrabold text-[#748282] uppercase tracking-wider" data-id="element-348">
                  Navigation
                </h3>
                <Link to="/" className="block text-xl font-bold text-slate-700 hover:text-[#3b7780]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-349">
                  Startseite
                </Link>
                <Link to="/termine" className="block text-xl font-bold text-slate-700 hover:text-[#3b7780]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-350">
                  Termine
                </Link>
                <Link to="/mediathek" className="block text-xl font-bold text-slate-700 hover:text-[#3b7780]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-351">
                  Mediathek
                </Link>
                <Link to="/kontakt" className="block text-xl font-bold text-slate-700 hover:text-[#3b7780]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-352">
                  Kontakt
                </Link>
              </div>

              <div className="space-y-4 pt-6 border-t border-slate-100" data-id="element-353">
                <h3 className="text-xs font-extrabold text-[#748282] uppercase tracking-wider" data-id="element-354">
                  Kurse
                </h3>
                {COURSES.map(course => <Link key={course.slug} to={`/kurse/${course.slug}`} className="block text-base font-semibold text-slate-500 hover:text-[#3b7780]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-355">
                    {course.title}
                  </Link>)}
              </div>

              <div className="space-y-4 pt-6 border-t border-slate-100" data-id="element-356">
                <h3 className="text-xs font-extrabold text-[#748282] uppercase tracking-wider" data-id="element-357">
                  Referenten
                </h3>
                {SPEAKERS.map(speaker => <Link key={speaker.slug} to={`/referenten/${speaker.slug}`} className="block text-base font-semibold text-slate-500 hover:text-[#3b7780]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-358">
                    {speaker.name}
                  </Link>)}
              </div>
            </div>
            <div className="p-6 border-t border-slate-100 bg-slate-50 flex-shrink-0" data-id="element-359">
              <Link to="/kontakt" className="block w-full text-center bg-[#3b7780] hover:bg-[#2d5f66] text-white px-6 py-4 rounded-md font-bold transition-colors shadow-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-360">
                Jetzt buchen
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}